import { useState } from "react";
import { getImpersonationMeta, stopImpersonation } from "@/lib/impersonation";

/** Bright, unmissable — deliberately not styled like the rest of the app's
 * muted UI chrome. This must never be something a super_admin could fail
 * to notice while browsing as someone else. */
export function ImpersonationBanner() {
  const meta = getImpersonationMeta();
  const [exiting, setExiting] = useState(false);
  if (!meta) return null;

  async function handleExit() {
    setExiting(true);
    try {
      await stopImpersonation();
    } catch {
      setExiting(false);
    }
  }

  return (
    <div className="flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-black">
      <span>
        You are impersonating{" "}
        <strong>{meta.target.name ?? meta.target.email}</strong>{" "}
        <span className="opacity-80">({meta.target.email})</span> in{" "}
        <strong>{meta.org.name}</strong>.
      </span>
      <button
        type="button"
        onClick={handleExit}
        disabled={exiting}
        className="rounded-md bg-black/80 px-3 py-1 text-xs font-semibold text-white hover:bg-black disabled:opacity-50"
      >
        {exiting ? "Exiting…" : "Exit impersonation"}
      </button>
    </div>
  );
}
